var Instance = {}

Instance.depthFirstInTree = function(treeData, targetValue, key = 'items', valueKey = 'id') {
    if(treeData && treeData[valueKey] && treeData[valueKey] == targetValue) {
        return [treeData];
    }

    if(! (treeData instanceof Array) ) {
        treeData = treeData[key];
    }
    var ret = [];

    var find = function(list, arr, isFind) {
        if(!list || !list.length) {
            return;
        }
        for(var i = 0; i < list.length; i ++) {
            if(isFind) {
                return;
            }
            var model = list[i];
            arr.push(model);
            if(model[valueKey] == targetValue) {
                ret = arr;
                isFind = true;
                return;
            }
            if(model[key] && model[key].length) {
                find(model[key], arr.concat([]));
            }
            arr.pop();
        }
        if(i === list.length) {
            arr.pop();
        }
    };
    find(treeData, [], false);

    return ret.reverse();
}

Instance.getParentChildren = function(treeData, targetValue, key = 'items', valueKey = 'id') {
     if(treeData && treeData[valueKey] && treeData[valueKey] == targetValue) {
        return [treeData];
    }

    if(! (treeData instanceof Array) ) {
        treeData = treeData[key];
    }
    

    var find = function(data){
        var ret;

        for(var i = 0; i < data.length; i++){
            var item = data[i];
            if(item[valueKey] == targetValue){
                return data;
            }else if(item[key] && item[key].length){
                var result = find(item[key]);
                if(result) return result;
            }
        }

        return ret;
    }
}




Instance.filterTree = function(treeData, keywords, childKey = 'items', targetKey = 'name') {
    if(!keywords) {
        return treeData;
    }

    keywords = keywords.toLowerCase();

    var filterOne = function(model, keywords) {
        //无需处理后续以及上级节点--
        if(model[targetKey].toLowerCase().indexOf(keywords) !== -1) {
            return true;
        }

        if(model[childKey] && model[childKey].length) {
            model[childKey] = model[childKey].filter(one => {
                return filterOne(one, keywords);
            })
            
            return model[childKey].length > 0;
        }
        
        return false;
    }

    let ret = window.$.extend(true, {}, treeData);
    
    filterOne(ret, keywords);

    return ret;
}

Instance.listToTree = function(list, idKey, parentIdKey, rootId, limitedLevel, childKey) {
    if(!list || !list.length) {
        return null;
    }
    list = list.slice(0);
    if(!idKey) {
        idKey = 'id';
    }
    if(!parentIdKey) {
        parentIdKey = 'parentId';
    }
    if(!rootId) {
        rootId = 1;
    }
    if(!childKey) {
        childKey = 'items';
    }

    var rootNode = {};
    rootNode[idKey] = rootId;
    rootNode[parentIdKey] = 0;
    list.sort(function(a, b) {
        return a[parentIdKey] - b[parentIdKey];
    });

    var len = list.length;
    var map = {};
    map[rootId] = rootNode;

    var getLevel = function(item) {
        item = window.$.extend({}, item);
        var level = 1;
        while(item[parentIdKey] != rootId && item[parentIdKey] > 0) {
            item = map[item[parentIdKey]];
            level ++;
        }

        return level;
    }

    for(var i = 0; i < len; i ++) {
        var item = list[i];
        var id = item[idKey];
        var parentId = item[parentIdKey];
        if(!map[parentId]) {
            console.log('Tree 数据错误，节点未找到父节点；', item);
            return null;
        }
        var level = getLevel(item);
        if(limitedLevel !== undefined && level > limitedLevel) {
            continue;
        }

        if(!map[parentId][childKey]) {
            map[parentId][childKey] = [];
        }
        map[parentId][childKey].push(item);
        map[id] = item;
    }

    return map[rootId];
}

//简单加密算法
Instance.encrypt = function(str) {
    if(!str) {
        return str;
    }

    var ret = '';
    for(var i = 0; i < str.length; i ++) {
        var code = str[i].charCodeAt();
        ret += code.toString().length.toString() + code.toString();
    }

    return ret;
}

Instance.decrypt = function(str) {
    if(!str) {
        return str;
    }

    var ret = '';
    for (var pos = 0; pos < str.length;) {
        var codeLen = parseInt(str.substr(pos, 1));
        var code = str.substr(pos + 1, codeLen);
        ret += String.fromCharCode(code);
        pos += codeLen + 1;
    }

    return ret;
}

Instance.getSingle = function(fn) {
    var ret;
    return function() {
        return ret || (ret = fn.apply(this, arguments));
    }
}

export default Instance;




// WEBPACK FOOTER //
// ./src/js/algorithm.js